import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('frontier-currency-field-formatconfig-query');
	},
};
